var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"current-version-container flex-align-center"},[_vm._v(_vm._s(_vm.keepNoun ? 'Version ' : '')+_vm._s(_vm.versionNumber))])
}
var staticRenderFns = []

export { render, staticRenderFns }